'use client';
import {HttpClient} from "@web-libs/core/http";
import {buildFetchFunction} from "@web-libs/core/http/infrastructure/shared/build-fetch-function";
import {RequestOptions} from "@web-libs/core/http/api/http.types";
import {RequestInitTransformer} from "@web-libs/core/http/infrastructure/shared/_build_fetch_options";
import {createHttpClient} from "@web-libs/core/http/infrastructure/shared/create-http";
import {ResponseInterceptor} from "@web-libs/core/http/infrastructure/shared/shared.types";
import {with_} from "@web-libs/util/with/with";

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

let id = 0;

export interface HttpConcern extends HttpClient {
    setAuthToken(token: string | null): void
    addResponseInterceptor(interceptor: ResponseInterceptor): void
    id?: number
    tenantId?: string
}

export const createHttpConcern = (tenantId: string, lang?: string): HttpConcern => {
    const _id = ++id
    if (!baseUrl) throw new Error("NEXT_PUBLIC_BASE_URL is not set")

    let authToken: string | null = null
    let responseInterceptors: ResponseInterceptor[] = []

    const addAuthToken: RequestInitTransformer = (requestInit: RequestInit, options?: RequestOptions): RequestInit => {
        if (!authToken || options?.skipAuthorization) return requestInit
        return {
            ...requestInit,
            headers: {
                ...requestInit.headers,
                Authorization: `Bearer ${authToken}`
            }
        }
    }

    const disableCache: RequestInitTransformer = (requestInit:RequestInit, _) => {
        return with_(requestInit, {cache: 'no-store'})
    }

    const addResponseInterceptor = (interceptor: ResponseInterceptor) => {
        responseInterceptors = [...responseInterceptors, interceptor]
    }

    const _fetch =  (method: string, url: string, body?: any, requestOptions?: (RequestOptions | undefined)) => {
        const builtFetch = buildFetchFunction(baseUrl, [addAuthToken.bind(this), disableCache], responseInterceptors)
        return builtFetch(method, url, body, requestOptions)
    }

    const httpClient = createHttpClient(
        baseUrl,
        _fetch,
        {},
        tenantId, lang
    )

    return {
        ...httpClient,
        setAuthToken: (token: string) => {
            authToken = token
        },
        addResponseInterceptor,
        id: _id,
        tenantId:tenantId
    }
}
